import styled from "styled-components";


export const DropDownsSeparatorBox = styled.div`
    width: 50px;
    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        display: none;
    }
`;
